import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { authService } from "@/services/authService";
import { courseService } from "@/services/courseService";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = guest, object = user
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("lm_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const data = await authService.me();
      setUser(data.user);
    } catch {
      localStorage.removeItem("lm_token");
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const setSession = (token, u) => {
    localStorage.setItem("lm_token", token);
    setUser(u);
    const sid = localStorage.getItem("lm_guest_session");
    if (sid) {
      courseService.claim(sid)
        .then((r) => { if (r?.claimed > 0) toast.success("Your demo course was saved to your library!"); })
        .catch(() => {})
        .finally(() => localStorage.removeItem("lm_guest_session"));
    }
  };

  const logout = async () => {
    try { await authService.logout(); } catch {}
    localStorage.removeItem("lm_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, setSession, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
